import { render, staticRenderFns } from "./RemDraftList.vue?vue&type=template&id=6a17f1cd&"
import script from "./RemDraftList.vue?vue&type=script&lang=js&"
export * from "./RemDraftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports